<template>
  <div class="login">
    <div class="clearfix">
      <div class="float-right">
        <div class="box pass">
          <template v-if="certData?.owner">
            <h3>Pozdravljeni, {{ userData ? userData.fullName : 'Gost' }}</h3>
            <template v-if="certData?.valid === true">
              <form v-if="userData" class="padding-top20">
                <InputWrapper :errors="errorMap($appErrors, 'password')" :positionAbsolute="false">
                  <label for="password" class="form-lable">Geslo: </label>
                  <InputPassword id="password" v-focus v-model="data.password" />
                </InputWrapper>
                <div class="padding-top5">
                  <a href @click.prevent="lostPassword">Pozabljeno geslo?</a>
                </div>
                <div v-if="lostPasswordEmail" class="toast toast-success margin-top20">
                  Novo geslo vam je bilo poslano na <u>{{ lostPasswordEmail }}</u
                  >.
                </div>
                <div>
                  <button class="button margin-top20" @click.prevent="login">Prijava</button>
                </div>
              </form>
              <div v-else>
                <button class="button margin-top20" @click.prevent="$router.push({ name: 'registration' })">Registracija</button>
              </div>
            </template>
            <template v-else>
              <div class="toast toast-error margin-top20">Certifikatu sistem ne zaupa. Nepravilen izdajatelj certifikata.</div>
            </template>
            <table class="padding-top40">
              <tr>
                <td colspan="2">Digitalno potrdilo:</td>
              </tr>
              <tr>
                <td>Lastnik:</td>
                <td>{{ certData.owner }}</td>
              </tr>
              <tr>
                <td>Izdajatelj:</td>
                <td>{{ certData.issuer }}</td>
              </tr>
              <tr>
                <td>Veljavnost:</td>
                <td>{{ certData.validFromTo }}</td>
              </tr>
            </table>
          </template>
          <template v-else>
            <h3>Pozdravljeni</h3>
            Ustrezno digitalno potrdilo ni izbrano. Zaprite brskalnik in poizkusite znova.
          </template>
        </div>
      </div>
    </div>
    <NewsTop />
  </div>
</template>

<script lang="ts">
import InputWrapper from '@/components/common/InputWrapper.vue'
import InputPassword from '@/components/common/InputPassword.vue'
import { useApi } from '@/lib/api'
import { useStore } from 'vuex'
import { GlobalState } from '@/lib/types'
import { useRouter } from 'vue-router'
import { errorMap } from '@/lib/filters'
import { defineComponent, ref, getCurrentInstance } from 'vue'
import NewsTop from '@/components/NewsTop.vue'

export default defineComponent({
  components: { InputWrapper, NewsTop, InputPassword },
  setup() {
    const _api = useApi()
    const _inst = getCurrentInstance()
    const _store = useStore<GlobalState>()
    const _router = useRouter()
    const data = ref({})
    const certData = ref({})
    const userData = ref({})
    const lostPasswordEmail = ref()

    const login = async () => {
      lostPasswordEmail.value = null

      const res = await _api.post<any>('login', data.value)
      if (res.status === 200) {
        _store.commit('user', res.data)
        _router.push({ name: 'reportList' })
      }
    }

    const getCert = async () => {
      try {
        const res = await _api.axios.get<any>('cert')
        if (res.status === 200) {
          certData.value = res.data.cert
          userData.value = res.data.user
        }
      } catch (e) {
        if (e.response.status === 403) {
          _store.commit('appErrors', [{ key: '.', message: 'Izbrano je nekvalificirano potrdilo' }])
        }
      }
    }

    const lostPassword = async () => {
      lostPasswordEmail.value = null
      const res = await _api.post<any>('lostPassword', null)
      if (res.status === 200) {
        lostPasswordEmail.value = res.data
        _inst?.appContext.config.globalProperties.emitter.emit('showToaster', { theme: 'green', text: 'Novo geslo poslano.' })
      }
    }

    getCert()

    return { certData, userData, data, errorMap, login, lostPassword, lostPasswordEmail }
  }
})
</script>

<style lang="scss" scoped>
.login {
  padding: 24px 45px;
  background: url('../assets/bgIndex.png') 0 -90px no-repeat #fff;

  .box h3 {
    font-size: 20px;
    font-weight: normal;
    color: #111;
  }

  .box.pass {
    margin-top: 20px;
    padding: 43px 65px;
    width: 485px;
  }
}
</style>
